import React from "react";
import { Link } from "react-router-dom";


//Images
import FSSC22000 from "../assets/img/certification/fssc.png"
import MadeInBelgium from "../assets/img/certification/Made-in-belgium.svg"
import HACCP from "../assets/img/certification/haccp.png"
import BIO from "../assets/img/certification/bio.png"

function Certification() {

    return (
        <>
            <div className="grid grid-cols-1 gap-20 items-center md:grid-cols-2 mt-20 lg:mt-0">
                <Link to="https://www.fssc.com/schemes/fssc-22000/">
                    <img
                        src={FSSC22000}
                        width={150}
                        height={100}
                        className={"object-cover"}
                        alt="Logo FSSC22000"
                        loading="lazy"
                    />
                </Link>
               
                <Link to="https://www.health.belgium.be/fr/alimentation/securite-alimentaire/dangers-microbiologiques-et-hygiene/haccp-autocontrole-et-0"
                ><img
                        width={150}
                        height={100}
                        src={HACCP}
                        className={"object-cover"}
                        alt="Logo HACCP"
                        loading="lazy"
                    />
                </Link>
                <Link to="https://agriculture.ec.europa.eu/farming/organic-farming/organic-logo_fr">
                    <img
                        width={150}
                        height={100}
                        src={BIO}
                        alt="Logo BIO"
                        loading="lazy"
                    />
                </Link>
                <Link to="https://www.belgium.be">
                    <img
                        width={150}
                        height={100}
                        src={MadeInBelgium}
                        className={"object-cover"}
                        alt="Logo Made in Belgium"
                        loading="lazy"
                    />
                </Link>
            </div>

        </>
    )
}

export default Certification